var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import FromEmailAddressDomainService from "../Domain/FromEmailAddress/FromEmailAddress.service";
const BASE_URL = "/aviso/fromEmailAddress";
export default class FromEmailAddressService {
    static searchFromAddress(search = {}, options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const repo = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                ids: search === null || search === void 0 ? void 0 : search.ids,
                createdByIds: search === null || search === void 0 ? void 0 : search.createdByIds,
                createdFrom: search === null || search === void 0 ? void 0 : search.createdFrom,
                createdTo: search === null || search === void 0 ? void 0 : search.createdTo,
                isExpired: search === null || search === void 0 ? void 0 : search.isExpired,
                fromNameLike: search === null || search === void 0 ? void 0 : search.fromNameLike,
                fromEmailLike: search === null || search === void 0 ? void 0 : search.fromEmailLike,
                isVerified: search === null || search === void 0 ? void 0 : search.isVerified,
                query: search === null || search === void 0 ? void 0 : search.query,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
            });
            return Object.assign(Object.assign({}, repo), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: (_a = repo.data) === null || _a === void 0 ? void 0 : _a.map(FromEmailAddressDomainService.fromJSON) });
        });
    }
}
